import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import omit from "lodash/omit";
import { useMemo } from "react";

import { calendarQueryKeys } from "../calendar";
import { eventOccurrenceQueryKeys } from "./eventOccurrenceQueryKeys";

export function useEventOccurrenceDelete(
  {
    api,
  }: {
    api: ApiType;
  },
  mutationOptsParams?: UseMutationOptions<
    unknown,
    unknown,
    { occurrenceId: number; isDeleteAll: boolean }
  >,
) {
  const queryClient = useQueryClient();

  const mutationOpts = useMemo(
    () => omit(mutationOptsParams, "onSuccess"),
    [mutationOptsParams],
  );

  return useMutation({
    mutationFn: ({
      occurrenceId,
      isDeleteAll,
    }: {
      occurrenceId: number;
      isDeleteAll: boolean;
    }) => api.eventApi.delete(occurrenceId, isDeleteAll),
    onSuccess: (data, variables, context) => {
      if (mutationOptsParams?.onSuccess) {
        mutationOptsParams.onSuccess(data, variables, context);
      }
      queryClient.invalidateQueries({
        queryKey: eventOccurrenceQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: calendarQueryKeys.eventOccurrences(),
      });
    },
    ...mutationOpts,
  });
}
